import { useState, useEffect, useCallback, useRef } from "react";
import style from "./Lightbox.Module.css";

export const Lightbox = ({ photos, startIndex, onClose }) => {
    const [current, setCurrent] = useState(startIndex);
    const touchStartX = useRef(null);

    const prev = useCallback(() => setCurrent(i => (i - 1 + photos.length) % photos.length), [photos.length]);
    const next = useCallback(() => setCurrent(i => (i + 1) % photos.length), [photos.length]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'ArrowRight') next();
            if (e.key === 'ArrowLeft') prev();
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [next, prev, onClose]);

    const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
    const onTouchEnd = (e) => {
        if (touchStartX.current === null) return;
        const diff = touchStartX.current - e.changedTouches[0].clientX;
        if (diff > 50) next();
        else if (diff < -50) prev();
        touchStartX.current = null;
    };

    return (
        <div className="lightbox-overlay" onClick={onClose} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            <button className="lightbox-close" onClick={onClose}>✕</button>
            <button className="lightbox-prev" onClick={e => { e.stopPropagation(); prev(); }}>‹</button>
            <img
                className="lightbox-img"
                src={photos[current].image}
                alt={photos[current].alt}
                onClick={e => e.stopPropagation()}
            />
            <button className="lightbox-next" onClick={e => { e.stopPropagation(); next(); }}>›</button>
            <div className="lightbox-dots" onClick={e => e.stopPropagation()}>
                {photos.map((_, i) => (
                    <span
                        key={i}
                        className={i === current ? "lightbox-dot lightbox-dot-active" : "lightbox-dot"}
                        onClick={() => setCurrent(i)}
                        onTouchEnd={(e) => { e.stopPropagation(); setCurrent(i); }}
                    />
                ))}
            </div>
        </div>
    );
};
